<template>
    <!-- eslint-disable max-len -->
    <PtHeaderDropdown
        class="patsnap-biz-languages"
        :trigger="$attrs.trigger"
    >
        <template #reference="{ open }">
            <PtHeaderWidget
                icon="SolidTranslateEnglish"
                class="patsnap-biz-header-widget"
                :label="$t('PtSelectLanguage.language')"
                :post-icon="arrow === 'down' ? (open ? 'SolidDropdownClose' : 'SolidDropdownOpen'): 'SolidDropdownRight'"
            />
        </template>
        <template #popper>
            <PtList
                class="patsnap-biz-languages__popper"
                :items="items"
                @itemClick="handleItemClick"
            />
        </template>
    </PtHeaderDropdown>
</template>

<script>
import PtList from '@patsnap-biz/list';
import PtHeaderDropdown from './HeaderDropdown';
import PtHeaderWidget from './HeaderWidget';
import cn from '../locales/languages/cn';
import en from '../locales/languages/en';
import jp from '../locales/languages/jp';
import tw from '../locales/languages/tw';

export default {
    name: 'PtSelectLanguage',
    i18n: {
        fallbackLocale: 'cn',
        messages: {
            cn, en, jp, tw,
        },
    },
    components: {
        PtList,
        PtHeaderWidget,
        PtHeaderDropdown,
    },
    props: {
        arrow: {
            type: String,
            default: 'down',
        },
        value: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        items() {
            return this.value.map((item) => ({
                ...item,
                postIcon: 'SolidTick',
            }));
        },
    },
    methods: {
        handleItemClick(item) {
            this.$emit('change', item.key);
        },
    },
};
</script>
